var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      _c(
        "q-table",
        {
          attrs: {
            data: _vm.pending,
            columns: _vm.columnsOnView(),
            "row-key": "id",
            flat: "",
            pagination: _vm.server_pagination,
            loading: _vm.loading,
            "rows-per-page-options": [5, 10, 50, 100]
          },
          on: {
            "update:pagination": function($event) {
              _vm.server_pagination = $event
            },
            request: _vm.request
          },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function() {
                return [
                  _c("q-input", {
                    staticClass: "q-mb-md",
                    attrs: {
                      debounce: "300",
                      placeholder: _vm.$t("search"),
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.request({
                          pagination: _vm.server_pagination
                        })
                      }
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "header",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                )
              }
            },
            {
              key: "body",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "id", attrs: { props: props } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.row.id) + "\n        "
                      )
                    ]),
                    _c("q-td", { key: "user", attrs: { props: props } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.row.user) + "\n        "
                      )
                    ]),
                    _c("q-td", { key: "user_email", attrs: { props: props } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.user_email) +
                          "\n        "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "reward_product", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.row.reward_product) +
                            "\n        "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "reward_product_title", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.row.reward_product_title) +
                            "\n        "
                        )
                      ]
                    ),
                    _c("q-td", { key: "price", attrs: { props: props } }, [
                      _vm._v(
                        "\n          " + _vm._s(props.row.price) + "\n        "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "created_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(props.row.created_date)) +
                            "\n        "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "actions", attrs: { props: props } },
                      [
                        _c("q-btn", {
                          attrs: {
                            flat: "",
                            color: "positive",
                            icon: "check",
                            label: "Aprovar"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openJustificationModal(
                                props.row,
                                "approve"
                              )
                            }
                          }
                        }),
                        _c("q-btn", {
                          attrs: {
                            flat: "",
                            color: "negative",
                            icon: "close",
                            label: "Reprovar"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openJustificationModal(
                                props.row,
                                "reject"
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            }
          ])
        },
        [
          _c(
            "q-tr",
            { attrs: { slot: "bottom-row" }, slot: "bottom-row" },
            [
              _c(
                "q-td",
                { attrs: { colspan: "100%" } },
                [
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        flat: "",
                        round: "",
                        dense: "",
                        color: "secondary",
                        size: "small",
                        icon: "far fa-cog"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_modal = true
                        }
                      }
                    },
                    [
                      _c("q-tooltip", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("configure_table_tooltip")) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return column.name !== "actions" && column.name !== "id"
                      ? _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-4" },
                          [
                            _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fal fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveColumns()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.showJustificationModal
        ? _c(
            "q-modal",
            {
              attrs: {
                persistent: "",
                size: "md",
                loading: _vm.loading,
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": ""
              },
              model: {
                value: _vm.showJustificationModal,
                callback: function($$v) {
                  _vm.showJustificationModal = $$v
                },
                expression: "showJustificationModal"
              }
            },
            [
              !_vm.loading
                ? _c(
                    "q-modal-layout",
                    { staticClass: "q-px-md q-pb-md" },
                    [
                      _c("h4", { staticClass: "q-mb-md" }, [
                        _vm._v(
                          "\n          Justificativa para " +
                            _vm._s(
                              _vm.selectedAction === "approve"
                                ? "aprovação"
                                : "reprovação"
                            ) +
                            "\n        "
                        )
                      ]),
                      _c(
                        "q-card-main",
                        [
                          _c("q-input", {
                            attrs: {
                              type: "textarea",
                              error: _vm.$v.justification.$error,
                              placeholder: "Justificativa pública",
                              rows: "4",
                              autofocus: ""
                            },
                            model: {
                              value: _vm.justification,
                              callback: function($$v) {
                                _vm.justification = $$v
                              },
                              expression: "justification"
                            }
                          }),
                          _c("q-input", {
                            staticClass: "q-mt-md q-w-100",
                            attrs: {
                              type: "textarea",
                              placeholder: "Observação Interna",
                              rows: "4"
                            },
                            model: {
                              value: _vm.internal_comment,
                              callback: function($$v) {
                                _vm.internal_comment = $$v
                              },
                              expression: "internal_comment"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-card-actions",
                        [
                          _c("q-btn", {
                            attrs: { flat: "", label: "Cancelar" },
                            on: { click: _vm.closeJustificationModal }
                          }),
                          _c("q-btn", {
                            attrs: {
                              color:
                                _vm.selectedAction === "approve"
                                  ? "positive"
                                  : "negative",
                              label:
                                _vm.selectedAction === "approve"
                                  ? "Aprovar"
                                  : "Reprovar"
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedAction === "approve"
                                  ? _vm.approve(_vm.selectedItem)
                                  : _vm.reject(_vm.selectedItem)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "q-modal-layout",
                    { staticClass: "row items-center justify-center" },
                    [
                      _c("q-spinner-dots", {
                        attrs: { size: 60, color: "secondary" }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }